import React from 'react';
import classNames from 'classnames/bind';
import {
  Button, Card, CardContent, CardTitle, CardFootnote, Image
} from '@thd-olt-component-react/core-ui';
import { string, arrayOf } from 'prop-types';
import styles from './recent-order-details.module.scss';

const RecentOrderContent = ({ orderPlacedText, formattedOrderDate, productImages, moreItemsText }) => {
  return (
    <Card>
      <CardTitle
        title="Your Latest Order"
        action={{ href: '/order/view/summary/', content: <Button link transparent>View Details</Button> }}
        className="card__title u-width-100"
      />
      <CardContent className="u-width-100">
        <div className={classNames(styles['recent-order-details'])}>
          <hr />
          <div className={classNames(styles['recent-order-details__orderDate'])}>
            <div className={classNames(styles['recent-order-details__success-text'])}>
              {orderPlacedText}
            </div>
            <div>{formattedOrderDate}</div>
          </div>
          <hr />
          <div className={classNames(styles['recent-order-details__img-container'])}>
            {productImages}
          </div>
          <div className={classNames(styles['recent-order-details__more-text'])}>
            {moreItemsText}
          </div>
        </div>
      </CardContent>
      <CardFootnote link={{ label: 'All Orders and Purchases', href: '/order/view/summary/' }} />
    </Card>
  );
};

RecentOrderContent.propTypes = {
  orderPlacedText: string,
  formattedOrderDate: string,
  productImages: arrayOf(Image),
  moreItemsText: string,
};

RecentOrderContent.defaultProps = {
  orderPlacedText: null,
  formattedOrderDate: null,
  productImages: null,
  moreItemsText: null,
};

export { RecentOrderContent };
